import {SearchModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {DietaryIndicatorData} from "./dietary-indicator.data";

@Injectable()
export class DietaryIndicatorSearchModel extends SearchModel<DietaryIndicatorData> {

    constructor(injector: Injector) {
        super(injector, DietaryIndicatorData);
    }

    override getIdentifierField(): string {
        return "id";
    }

    override isEntityLocalisable(): boolean {
        return false;
    }
}
